import { useTheme } from '@material-ui/core/styles';
import { MdOutlinePendingActions } from 'react-icons/md';
import { lighten } from 'polished';

import { Card, ICardsProps } from '../../../../components/Card';
import { useSettings } from '../../../../hooks/settings';

export const PendingOrdersCard = (
  props: Pick<ICardsProps, 'content' | 'percentage' | 'loading' | 'onClick'>
) => {
  const theme = useTheme();
  const { cardsLoading } = useSettings();

  return (
    <Card
      title="Pendentes"
      invertPercentageColors
      icon={<MdOutlinePendingActions />}
      cardColor={lighten(0.325, theme.palette.grey[600])}
      loading={cardsLoading}
      {...props}
    />
  );
};
